import { Theme } from '@mui/material/styles'

const muiInputAdornment = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        '& svg': {
          height: '1.25rem',
          width: '1.25rem',
          fontSize: '1.25rem'
        }
      },
      positionStart: {
        marginRight: '0.2rem',
        '&~input': {
          paddingLeft: '0.625rem'
        }
      }
    }
  }
}

export default muiInputAdornment
